import { Link } from "react-router-dom";
import { Card, CardBody, Col, FormGroup, Input, Label, Table } from "reactstrap";
import { H6, Image, ProgressBar } from "../../../../../AbstractElements";
import { TransactionTitle } from "../../../../../Constants/Constants";
import { TransactionData } from "../../../../../Data/General/Dashboard/Default";
import { dynamicImage } from "../../../../../Utils";
import DashboardCommonHeader from "../../../../CommonComponents/DashboardCommonHeader/DashboardCommonHeader";

const Transaction = () => {
  return (
    <Col xl="7" md="6">
      <Card className="transaction-table">
        <DashboardCommonHeader title={TransactionTitle} dropdownClass="dropdown-toggle" />
        <CardBody>
          <div className="table-responsive custom-scrollbar">
            <Table className="display">
              <thead>
                <tr>
                  <th>
                    <FormGroup check>
                      <Input type="checkbox" />
                      <Label check />
                    </FormGroup>
                  </th>
                  <th>Item Name</th>
                  <th>Date and Time</th>
                  <th>Income</th>
                  <th>Progress</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {TransactionData.map((data, index) => (
                  <tr key={index}>
                    <td>
                      <FormGroup check>
                        <Input type="checkbox" />
                        <Label check />
                      </FormGroup>
                    </td>
                    <td>
                      <div className="d-flex gap-2">
                        <div className="flex-shrink-0"><Image src={dynamicImage(data.image)} alt="user" /></div>
                        <div className="flex-grow-1">
                          <Link to={`${process.env.PUBLIC_URL}/applications/ecommerce/product`}>
                            <H6 className="f-w-500">{data.title}</H6>
                            <span>{data.text}</span>
                          </Link>
                        </div>
                      </div>
                    </td>
                    <td>
                      <H6>{data.date}</H6>
                      <span>{data.time}</span>
                    </td>
                    <td className="f-w-500">{data.income}</td>
                    <td><ProgressBar value={60} color={data.color} /></td>
                    <td><span className={`f-w-500 btn bg-light-${data.color} txt-${data.color}`}>{data.status}</span></td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default Transaction;
